import React from 'react';
import './CopyrightNotice.css'; // Assuming you create a separate CSS file for styles

const CopyrightNotice = () => {
  return (
    <div className="container">
      <h1>Copyright Notice</h1>
      <p>© 2025 <strong>IronBhai</strong>. All Rights Reserved.</p>
      <p><strong>IronBhai</strong> and the IronBhai logo are trademarks of IronBhai. All other trademarks, service marks, trade names, product names, and logos appearing on this website are the property of their respective owners.</p>

      <h2>Ownership of Content</h2>
      <p>All content, designs, graphics, logos, text, images, videos, software, and other materials (“Content”) displayed on this website and in the IronBhai mobile applications are the property of IronBhai unless otherwise noted. Unauthorized use, reproduction, or distribution of any Content without prior written consent from IronBhai is strictly prohibited.</p>

      <h2>Use of Content</h2>
      <p><strong>You may not:</strong></p>
      <ul>
        <li>Copy, reproduce, republish, upload, post, transmit, or distribute any Content without permission.</li>
        <li>Use any trademarks, service marks, or logos from the IronBhai brand without written approval.</li>
      </ul>

      <p><strong>You may:</strong></p>
      <ul>
        <li>Share links to our official website or mobile apps without altering the original content.</li>
        <li>Download materials that are specifically made available for public use, provided you do not modify them and you retain all copyright and proprietary notices.</li>
      </ul>

      <h2>Third-Party Content</h2>
      <p>Some content may include materials from third parties. Such content remains the property of the respective owners, and all rights are reserved by them.</p>

      <h2>Contact Us</h2>
      <div className="contact">
        <p>For copyright inquiries, permissions, or questions about using IronBhai content, please contact:</p>
        <p>Email: <a href="mailto:support@ironbhai.com">support@ironbhai.com</a><br />
        Phone: <a href="tel:+918688206969">+91-8688206969</a><br />
        Address: Hyderabad, Telangana</p>
      </div>
    </div>
  );
};

export default CopyrightNotice;
